module.exports = __webpack_public_path__ + "img/aws-lambda.780b870e.svg";